<template>
    <div>
        <div v-if="hasInvoice">
            <h3 class="mt-0">
                {{ $l10n.__('Afficher les types de documents non utilisés') }}
            </h3>
            <p class="explain">
                {{
                    $l10n.__(
                        'Si vous nʼutilisez jamais certains types de documents et vous contentez, par exemple, des devis et factures, vous avez la possibilité de masquer certains types de documents afin d’alléger votre interface Sellsy. Vous pourrez à tout moment décider de les afficher à nouveau depuis cette même page.',
                    )
                }}
            </p>

            <el-checkbox-group v-model="doctypes">
                <div class="form-group">
                    <el-checkbox label="order">{{
                        $l10n.__('Afficher les bons de commande')
                    }}</el-checkbox>
                </div>
                <div class="form-group">
                    <el-checkbox label="delivery">{{
                        $l10n.__('Afficher les bons de livraison')
                    }}</el-checkbox>
                </div>
                <div class="form-group">
                    <el-checkbox label="proforma">{{
                        $l10n.__('Afficher les factures proforma')
                    }}</el-checkbox>
                </div>
            </el-checkbox-group>
        </div>

        <h3>
            {{ $l10n.__('Date de validité des devis et factures proforma') }}
        </h3>
        <div class="flex-level mt-3">
            <span>{{ $l10n.__('Un devis ou une facture proforma expire sous') }}</span>
            <el-input-number v-model="expirationTime" class="dinlineb mx-2 input-small" :min="1" />
            <span>{{ $l10n.__('jour(s)') }}</span>
        </div>

        <h3>
            {{ $l10n.__('Liens publics') }}
        </h3>
        <p>
            {{ $l10n.__('Définir si les liens publics de vos documents sont actifs par défaut.') }}
        </p>
        <div class="form-group">
            <el-checkbox v-model="publicLink">{{
                $l10n.__('Liens publics actifs par défaut')
            }}</el-checkbox>
        </div>

        <h3>
            {{ $l10n.__('Gestion des reliquats') }}
        </h3>
        <p>
            {{
                $l10n.__(
                    'La gestion des reliquats vous permet de calculer dynamiquement les quantités de vos documents en fonctions de leur historique.',
                )
            }}
        </p>
        <div class="alert alert-warning">
            <p>
                {{
                    $l10n.__(
                        'Attention, une fois la gestion des reliquats activée, les lignes identiques des documents seront regroupées lors des conversions dans le but de calculer les quantités restantes. Cette option est incompatible avec les produits sérialisés.',
                    )
                }}
            </p>
        </div>
        <div class="form-group">
            <el-checkbox v-model="reliquat">{{
                $l10n.__('Activer la gestion des reliquats')
            }}</el-checkbox>
        </div>

        <div class="mt-3">
            <CompassButton :label="$t.__('common.actions.save')" @click.prevent="save" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        defaultDoctypes: {
            type: Array,
            required: true,
        },
        defaultExpirationTime: {
            type: Number,
            required: true,
        },
        defaultPublicLink: {
            type: Boolean,
            required: true,
        },
        defaultReliquat: {
            type: Boolean,
            required: true,
        },
        docPrefsId: {
            type: Number,
            required: true,
        },
        hasInvoice: {
            type: Boolean,
            required: true,
        },
    },
    data: function () {
        return {
            doctypes: this.defaultDoctypes,
            expirationTime: this.defaultExpirationTime,
            publicLink: this.defaultPublicLink,
            reliquat: this.defaultReliquat,
        };
    },
    methods: {
        save: function () {
            const options = {
                doctypes: this.doctypes,
                expirationTime: this.expirationTime,
                publicLink: this.publicLink,
                reliquat: this.reliquat,
            };

            this.$ajax.put(
                `/rest/documents/main-preferences/${this.docPrefsId}`,
                {},
                options,
                (data) => {
                    Push.success(this.$l10n.__('Préférences enregistrées'));
                },
                (error) => {
                    const errors = {};
                    const messages = error.response.data.error.message;
                    Object.keys(messages).forEach(function (key) {
                        Push.error(messages[key]);
                    });
                },
            );
        },
    },
};
</script>
